import React from 'react';
import styles from './phone.module.scss';

import { toggleFlyingButton } from '../../reducers/quiz/quiz.actions';
import { useDispatch } from 'react-redux';
import { emitEvent } from '../../event-emitter';
import { EVENT_CLICK_HEADER_PHONE } from '../../constants';

interface PhoneProps {
	phone: string
}

export default function Phone(props:PhoneProps) {
	const dispatch = useDispatch();
	const clickHandler = () => emitEvent(EVENT_CLICK_HEADER_PHONE);

	return (
		<a className={styles.phone} 
			onClick={clickHandler}
			target="_blank"
			rel="noopener noreferrer"
			onMouseEnter={() => dispatch(toggleFlyingButton(false))}
			onMouseLeave={() => dispatch(toggleFlyingButton(true))}
			href={'tel:'+props.phone.replace(/[()-\s]/g, '')}>
			{props.phone}
		</a>
	)
}